<template>
<div class="chapter">
<div class="inner_page">
<h1 id="Title" title="Title Page">Murder on Mt. McKinley</h1>
<p class="subtitle">A Summit Murder Mystery</p>
<p class="firstauthor">Charles G. Irion</p>
<p class="center">and</p>
<p class="secondauthor">Ronald J. Watkins</p>
<p class="imagecenter"><img alt="CGI Irion Books LLC Logo" id="TitleLogo" src="Images/logo.png"/></p>
<p class="publisher"><a href="http://www.SummitMurderMystery.com" target="_blank">www.SummitMurderMystery.com</a></p>
<p class="publisher"><a href="http://www.IrionBooks.com" target="_blank">www.IrionBooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?4089cc74